import React from 'react';
import { Group, GenericSkeleton, useBreakpoint, Box } from '@landr/maestro';
import * as Styled from './styled';

const PreviewSamplesRowSkeleton = () => {
    const showCreatorButton = !useBreakpoint('xl');

    return (
        <Styled.PreviewSamplesRowItem isLoading={true} aria-busy="true">
            <Styled.PreviewSamplesRowGroup>
                <Group.Item>
                    <GenericSkeleton
                        width="36px"
                        height="36px"
                        variant="round"
                    />
                </Group.Item>
                <Styled.TagsAndWaveform isLoading={true}>
                    <Styled.WaveformContainer>
                        <GenericSkeleton width="100%" height="20px" />
                    </Styled.WaveformContainer>
                    <Box mt="5px">
                        <GenericSkeleton width="36px" height="14px" />
                    </Box>
                </Styled.TagsAndWaveform>
                <Group.Item>
                    <GenericSkeleton
                        width="36px"
                        height="36px"
                        variant="round"
                    />
                </Group.Item>
                <Group.Item>
                    <GenericSkeleton
                        width="36px"
                        height="36px"
                        variant="round"
                    />
                </Group.Item>
                {showCreatorButton && (
                    <Group.Item>
                        <GenericSkeleton
                            width="36px"
                            height="36px"
                            variant="round"
                        />
                    </Group.Item>
                )}
            </Styled.PreviewSamplesRowGroup>
        </Styled.PreviewSamplesRowItem>
    );
};

export const PreviewSamplesSkeleton = ({
    showColumnRight,
}: {
    showColumnRight: boolean;
}) => (
    <Styled.PreviewSamplesWrapper>
        <Styled.FlexStretch>
            <Styled.PreviewSamplesColumn>
                <Group direction="vertical" gutter={0}>
                    <PreviewSamplesRowSkeleton key="row-skeleton-1" />
                    <PreviewSamplesRowSkeleton key="row-skeleton-2" />
                    <PreviewSamplesRowSkeleton key="row-skeleton-3" />
                    <PreviewSamplesRowSkeleton key="row-skeleton-4" />
                </Group>
            </Styled.PreviewSamplesColumn>

            {showColumnRight && (
                <Styled.PreviewSamplesColumn>
                    <Group direction="vertical" gutter={0}>
                        <PreviewSamplesRowSkeleton key="row-skeleton-1" />
                        <PreviewSamplesRowSkeleton key="row-skeleton-2" />
                        <PreviewSamplesRowSkeleton key="row-skeleton-3" />
                        <PreviewSamplesRowSkeleton key="row-skeleton-4" />
                    </Group>
                </Styled.PreviewSamplesColumn>
            )}
        </Styled.FlexStretch>
    </Styled.PreviewSamplesWrapper>
);

export default PreviewSamplesSkeleton;
